import React, { useState, useRef, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Button, Form, Input, Dropdown, Loader } from "semantic-ui-react";
import TextEditor from "../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";

import { Container, Content, Title, Field, Label } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";

const EditarHistoria = (props) => {
  const description = useRef("");
  const [treinamentos, setTreinamentos] = useState([]);
  const [categorias, setCategorias] = useState();
  const [historia, setHistoria] = useState({});
  const [idTreinamento, setIdTreinamento] = useState(0);
  const [loading, setLoading] = useState(true);
  const areaValue = useRef({
    area: "",
    treinamento: "",
  });
  const id = props.match.params.id;

  useEffect(() => {
    loadAuth();
    loadHistoria();
    loadTreinamentos();
    loadCategorie();
  }, []);
  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadArea = async () => {
    await api
      .get(`/admin/treinamentos/${areaValue.current.treinamento}`,{
        headers: {
          access_token: `voitto-token ${localStorage.getItem(
            'oauth_token'
          )}`
        }
      }

)
      .then((res) => {
        areaValue.current["area"] = res.data.id_area;
      })
      .catch((err) => {
        swal("Não foi possível carregar as Historias", err, "error");
      });
  };

  const loadTreinamentos = async () => {
    await api
      .get(`/admin/treinamentos?all=1`,{
        headers: {
          access_token: `voitto-token ${localStorage.getItem(
            'oauth_token'
          )}`
        }
      })
      .then((res) => {
        const newTreinamentos = res.data.map((treinamento) => ({
          key: treinamento.id,
          value: treinamento.id,
          text: treinamento.nome,
        }));
        setTreinamentos(newTreinamentos);
      })
      .catch((err) => {
        swal("Não foi possível carregar as Historias", err, "error");
      });
  };

  const loadHistoria = async () => {
    await api
      .get(`/pessoa/depoimento/${id}`)
      .then(async (res) => {
        let array = {
          local: "historiaDeSucesso",
          texto: `listou a Historia de id=${id}`,
        };
        await api.post("system_logs", { acao: JSON.stringify(array) });
        setHistoria(res.data);
        setIdTreinamento(res.data.treinamento.id);
        areaValue.current["treinamento"] = res.data.treinamento.id;
      })
      .catch((err) => {
        swal("Não foi possível carregar a Historia", err, "error");
      });
  };

  const loadCategorie = async () => {
    await api
      .get(`/categories-personalite`)
      .then((res) => {
        const newCategorias = res.data.categories.map((categoria) => ({
          key: categoria.id,
          value: categoria.id,
          text: categoria.name,
        }));
        setCategorias(newCategorias);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar as Historias", err, "error");
      });
  };

  const update = async () => {
    await loadArea();

    const payload = {
      nome: historia.nome,
      id_treinamento: areaValue.current.treinamento,
      link_media: historia.link_media,
      parafrase: description.current,
      ordem: historia.ordem,
      id_area: areaValue.current.area,
      type_depoimento: historia.type_depoimento,
    };

    const historiaValidation = await yup.object().shape({
      nome: yup
        .string("Necessário que informe o nome do do depointe")
        .required("Necessário que informe o nome do do depointe"),
      link_media: yup
        .string("Necessário que informe o link da media")
        .required("Necessário que informe o link da media"),
      parafrase: yup
        .string("Necessário que informe a parafrase")
        .required("Necessário que informe a parafrase"),
      ordem: yup
        .string("Necessário que informe a ordem")
        .required("Necessário que informe a ordem"),
    });

    try {
      await historiaValidation.validate(payload, { abortEarly: true });
      api
        .put(`/pessoa/depoimento/${id}`, payload)
        .then(async () => {
          let array = {
            local: "historiaDeSucesso",
            texto: `editou a Historia de id=${id}`,
          };
          await api.post("system_logs", { acao: JSON.stringify(array) });
          swal(" Historia salva com sucesso", "", "success").then((res) =>
            props.history.push("/admindev/HistoriasDeSucesso")
          );
        })
        .catch((err) => {
          swal("Não foi possível salvar a Historia", err, "").then((res) =>
            props.history.push("/admindev/HistoriasDeSucesso")
          );
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Editar Historia</Title>

            <Form>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Nome do depointe"
                  placeholder="Nome do depointe"
                  value={historia.nome}
                  onChange={(e) => {
                    setHistoria({ ...historia, nome: e.target.value });
                  }}
                />
              </Form.Group>

              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Treinamento</Label>
                  <Dropdown
                    placeholder="Escolha um treinamento"
                    fluid
                    search
                    selection
                    options={treinamentos}
                    value={idTreinamento}
                    onChange={(e, data) => {
                      setIdTreinamento(data.value);
                      areaValue.current["treinamento"] = data.value;
                    }}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Label>Categorias</Label>
                  <Dropdown
                    placeholder="Escolha uma categoria"
                    fluid
                    search
                    selection
                    options={categorias}
                    value={historia.type_depoimento}
                    onChange={(e, data) => {
                      setHistoria({ ...historia, type_depoimento: data.value });
                    }}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Link da media(URL normal)"
                  placeholder="Link da media(URL normal)"
                  value={historia.link_media}
                  onChange={(e) => {
                    setHistoria({ ...historia, link_media: e.target.value });
                  }}
                />
              </Form.Group>

              <Field>
                <Label>Paráfrase</Label>
                <TextEditor
                  haveFullscreen
                  default={historia.parafrase}
                  text={description}
                />
              </Field>

              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Ordem"
                  placeholder="Ordem"
                  value={historia.ordem}
                  onChange={(e) => {
                    setHistoria({ ...historia, ordem: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Field control={Button} onClick={() => update()}>
                  Editar
                </Form.Field>
                <Link to="/admindev/HistoriasDeSucesso">
                  <Button color="secondary">Cancelar</Button>
                </Link>
              </Form.Group>
            </Form>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(EditarHistoria);
